// extracted by mini-css-extract-plugin
export default {"editorContent":"Content_editorContent__zdre+","content":"Content_content__3ZaEO"};